// @ts-ignore
import CryptoJS from "crypto-js";

export default class EncryptUtils {
  static encryptMD5(message: any) {
    return CryptoJS.MD5(message).toString();
  }
}
